export const ENDPOINTS = {
  BASE_URL: import.meta.env.VITE_API_URL,
  REGISTER: '/register',
  UPDATE: '/update',
  USAGE: '/usage',
  USER: '/user',
  CLOUDPAY: '/cloudpay',
  USER_LIST: '/userlist',
  CONTACT_US: '/contactus',
  CONTACT_US_PUBLIC: '/public/contact-us',
  OUTAGES: '/outages',
  USER_ADMIN: '/user-admin',
  VERIFY_ACCOUNT: '/verifyAccount',
  CHECK_EMAIL: '/checkEmail',
  CONFIRM_REGISTER: '/register/confirm',

  // ADMIN APIS
  REGISTER_ADMIN: '/registerAdmin',
  ADMIN_USER_LIST: '/adminuserlist',
  GET_ADMIN_USER: '/getadminuser',
  ADMIN: '/admin',
  ADMIN_USER: '/admingetuser',

  ACCOUNT: '/v2/account',
  ACCOUNT_EMAIL: 'v2/forgotEmail',
  IC_AUTH: '/v2/auth/ic',
  BILLING: '/v2/history/billing',
  USAGE_V2: '/v2/usage',
  PAYMENT: '/v2/history/payment',
  UPDATE_MAIL_ADDRESS: 'v2/mailingAddress',
  VERIFY_PAY_BILL: '/v2/payment/verify',
  SEARCH_LOCATION: '/v2/location',
  SERVICE_REQUEST: '/v2/service/request',
  DEPOSIT: 'v2/history/deposit',
  IC_LINK_ACCOUNT: '/v2/invoiceCloud/linkAccount',

  ACCOUNT_AUTH_ADMIN: '/v2/admin/account',
  BILLING_AUTH_ADMIN: '/v2/admin/history/billing',
  METER_HISTORY: '/v2/history/meter',
  USAGE_V2_AUTH_ADMIN: '/v2/admin/usage',
  PAYMENT_AUTH_ADMIN: '/v2/admin/history/payment',
  DEPOSIT_ADMIN: '/v2/admin/history/deposit',
  UPDATE_MAIL_ADDRESS_AUTH_ADMIN: 'v2/admin/mailingAddress',
  UPDATE_AUTH_ADMIN: 'admin/update',

  // guest user
  ADD_GUEST_USER: 'guestUser/add',
  LINK_GUEST_USER: 'guestUser/link',
  UNLINK_GUEST_USER: 'guestUser/unlink',

  // user management
  REQUEST_EMAIL_UPDATE: '/v2/user/requestEmailUpdate',
  CONFIRM_EMAIL_UPDATE: '/v2/user/confirmEmailUpdate',
  REQUEST_PASSWORD_CHANGE: '/v2/user/requestPasswordChange',
  CHANGE_PASSWORD: '/v2/user/changePassword',
  PASSWORD_RESET_CONFIRM: '/passwordChangeConfirmation',

  MAINTENANCE_MODE: '/settings/portal/public'
}
